import { render, staticRenderFns } from "./InfoRooms.vue?vue&type=template&id=3f4f4a72&"
import script from "./InfoRooms.vue?vue&type=script&lang=js&"
export * from "./InfoRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports